import {
  BaseEdge,
  type Edge,
  EdgeLabelRenderer,
  type EdgeProps,
  getBezierPath,
} from '@xyflow/react'
import { Tooltip } from 'antd'
import type { AuditEdgeData } from './auditLayout'

export type AuditEdgeType = Edge<AuditEdgeData, 'auditEdge'>

export function AuditEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  markerEnd,
  data,
}: EdgeProps<AuditEdgeType>) {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  })

  const color = data?.color ?? 'hsl(var(--muted-foreground))'

  return (
    <>
      <BaseEdge
        id={id}
        path={edgePath}
        markerEnd={markerEnd}
        style={{
          stroke: color,
          strokeWidth: 1.8,
          strokeDasharray: data?.dashed ? '6 4' : undefined,
        }}
      />
      {data?.tooltip ? (
        <EdgeLabelRenderer>
          <Tooltip title={data.tooltip} mouseEnterDelay={0}>
            <div
              className='nodrag nopan'
              style={{
                position: 'absolute',
                transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
                pointerEvents: 'all',
                width: 8,
                height: 8,
                borderRadius: '50%',
                background: color,
              }}
            />
          </Tooltip>
        </EdgeLabelRenderer>
      ) : null}
    </>
  )
}
